import React from "react";

function SyslogPortField({ value, onChange }) {

    const handleChange = async (value) => {
        onChange(value);
    }

    return (
        <div className="oct_settings-field">
            <label className="oct_settings-label">PORT</label>
            <input className="oct_settings-input-v2"
                id="port"
                value={value}
                placeholder="Enter port number"
                onChange={event => handleChange(event.target.value)} />
        </div>
    )
}

export default SyslogPortField;
